import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { createLnField, type LnField } from './lnField'

export interface LoginStageHandle {
  /** 打字时从输入框荡出一圈涟漪 */
  pulseFrom(el: HTMLElement): void
}

/** 登录页的整屏品牌背景：线场拼出 LN，再依次变成中台各功能的形状。纯装饰，对读屏隐藏。 */
export const LoginStage = forwardRef<LoginStageHandle>(function LoginStage(_, ref) {
  const stageRef = useRef<HTMLDivElement>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const field = useRef<LnField | null>(null)

  useEffect(() => {
    if (!stageRef.current || !canvasRef.current) return
    const f = createLnField(stageRef.current, canvasRef.current)
    field.current = f
    f.start()
    return () => {
      f.destroy()
      field.current = null
    }
  }, [])

  useImperativeHandle(ref, () => ({
    pulseFrom(el) {
      const r = el.getBoundingClientRect()
      field.current?.pulse(r.left + 24, r.top + r.height / 2)
    },
  }))

  return (
    <div className="login-stage" ref={stageRef} aria-hidden="true">
      <div className="login-orbs">
        <div className="o1"><i /></div>
        <div className="o2"><i /></div>
        <div className="o3"><i /></div>
      </div>
      <canvas className="login-field-canvas" ref={canvasRef} />
      <div className="login-scrim" />
      <p className="login-tag">原生智能</p>
      <div className="login-copy">
        <p className="login-copy-name">灵智原生</p>
        <p className="login-copy-line">智能，由内而生。</p>
      </div>
    </div>
  )
})
